var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex gap-8 ml-0 flex-column w-full md:w-2/3 lg:w-1/3"},[_c('FeaturesCheckboxes',{ref:"featuresCheckboxes",attrs:{"object":_vm.scope}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }